<template>

    <div class="body">
        <div class="body__container">
            <h2 class="text-xlBold">{{ $t('cleaning_sort_by') }}</h2>
        </div>

        <div class="body__container">
            <p class="text-lSemibold">{{ $t('cleaning_sort_open_rate') }}</p>
            <div class="body__row mt__12" @click="clickSort(ENUM.NEWSLETTERS.SORT.MOST_OPEN)">
                <img :src="newslettersSort === ENUM.NEWSLETTERS.SORT.MOST_OPEN ? checkTrue : checkFalse"
                     class="img__16 mr__8">
                <p class="text-baseMedium">{{ $t('cleaning_sort_more_open') }}</p>
            </div>
            <div class="body__row mt__10" @click="clickSort(ENUM.NEWSLETTERS.SORT.LEAST_OPEN)">
                <img :src="newslettersSort === ENUM.NEWSLETTERS.SORT.LEAST_OPEN ? checkTrue : checkFalse"
                     class="img__16 mr__8">
                <p class="text-baseMedium">{{ $t('cleaning_sort_less_open') }}</p>
            </div>
        </div>

        <div class="body__container">
            <p class="text-lSemibold">{{ $t('cleaning_nb_mail_received') }}</p>
            <div class="body__row mt__12" @click="clickSort(ENUM.NEWSLETTERS.SORT.ASCENDING)">
                <img :src="newslettersSort === ENUM.NEWSLETTERS.SORT.ASCENDING ? checkTrue : checkFalse"
                     class="img__16 mr__8">
                <p class="text-baseMedium">
                    {{ $t('cleaning_sort_ascending_order') }}
                </p>
            </div>
            <div class="body__row mt__10" @click="clickSort(ENUM.NEWSLETTERS.SORT.DESCENDING)">
                <img :src="newslettersSort === ENUM.NEWSLETTERS.SORT.DESCENDING ? checkTrue : checkFalse"
                     class="img__16 mr__8">
                <p class="text-baseMedium">{{ $t('cleaning_sort_descending_order') }}</p>
            </div>
        </div>

        <div class="body__container">
            <button class="body__btn text-baseBold-2 color__white" @click="valid">{{ $t('cleaning_validate_sort') }}
            </button>
        </div>

    </div>

</template>

<script>
import Vuex from 'vuex'

import ENUM from '@/assets/ENUM'

import Tag from '@/modules/tag'

export default {

    name: 'sort-body',

    computed: {

        ...Vuex.mapGetters(['newslettersSort']),

        ENUM() {
            return ENUM
        }
    },

    data() {
        return {
            sort: '',
            checkTrue: '/img/newsletters-v2/check-list-on.svg',
            checkFalse: '/img/newsletters-v2/check-list-off.svg',
        }
    },

    methods: {

        ...Vuex.mapActions(['updateNewslettersSort']),

        valid() {
            Tag.clickGA(this, 'validate')
            this.$emit('close')
        },

        clickSort(sortBy) {

            switch (sortBy) {
                case ENUM.NEWSLETTERS.SORT.MOST_OPEN:
                    Tag.clickGA(this, 'order_open_down')
                    break
                case ENUM.NEWSLETTERS.SORT.LEAST_OPEN:
                    Tag.clickGA(this, 'order_open_up')
                    break
                case ENUM.NEWSLETTERS.SORT.ASCENDING:
                    Tag.clickGA(this, 'order_email_up')
                    break
                case ENUM.NEWSLETTERS.SORT.DESCENDING:
                    Tag.clickGA(this, 'order_email_down')
                    break
            }

            this.updateNewslettersSort(sortBy)
        }
    }
}
</script>

<style lang="scss" scoped>

.body {
    width: 100%;

    &__container {
        width: 100%;
        padding: 16px;
        display: flex;
        flex-direction: column;
        text-align: left;
        border-bottom: 1px solid $divider;
    }

    &__row {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
    }

    &__btn {
        padding: 17px;
        background-color: $midnight;
        border-radius: 72px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
}
</style>
